export default "https://cdn-static.gokick.com/assets/f85860d356d81c773b535a0002382fa42e6b6edf/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";